import React, {useState, useEffect} from "react"
import "../App.css"
import ShiftCalendar from "./Shift_Calendar"
import ExclusionCalendar from "./ExclusionCalendar"
import axios from "axios"
import {SERVER_URI} from "../utility/config"
import {ReservedShifts} from "./ReservedShifts"

function Calendars(props) {
	//props.stopListRefresh()
	const [calendarType, setCalendarType] = useState("Reserved_Shifts")
	const dispatch = props.dispatch

	useEffect(() => {
		const fetchReservedWorkShifts = async () => {
			try {
				const userToken = window.localStorage.getItem("admin_token")
				if (!userToken) {
					console.log("Kirjaudu sisään")
					return
				}
				const response = await axios.get(`${SERVER_URI}/list_reserved_shifts/`, {
					headers: {Authorization: `Token ${userToken}`},
				})
				const updatedWorkShifts = response.data
				dispatch({type: "UPDATE_WORK_SHIFTS", data: {updatedWorkShifts}})
			} catch (error) {
				console.error("Error fetching reserved work shifts:", error)
			}

		}
		fetchReservedWorkShifts() // Initial fetch
		const pollWorkShifts = setInterval(() => {
			fetchReservedWorkShifts()
		}, 10000)

		return () => clearInterval(pollWorkShifts) // Cleanup on unmount
	}, [dispatch])

	const toggleCalendarType = (e) => {
		let type = e.target.value
		setCalendarType(type)
	}
	return (<div className="Calendars" style={{height: "fit-content", overflowY: "hidden"}}>
		{/*<button id="lightBlue_button" value="Shift_Calendar" onClick={toggleCalendarType}>Vuorokalenteri</button>*/}
		<button id="lightBlue_button" value="Reserved_Shifts" onClick={toggleCalendarType}>Vuorokalenteri</button>
		<button id="lightBlue_button" value="Exclusion_Calendar" onClick={toggleCalendarType}>Poikkeusajat</button>
		{calendarType === "Shift_Calendar" && <div>
			<ShiftCalendar driverList={props.driverList} workList={props.workList} dispatch={props.dispatch}
			               vehicleList={props.vehicleList} exclusionTimes={props.exclusionTimes}
			               stopListRefresh={props.stopListRefresh}/>
		</div>}
		{calendarType === "Exclusion_Calendar" && <div>
			<ExclusionCalendar exclusionTimes={props.exclusionTimes} dispatch={props.dispatch}
			                   stopListRefresh={props.stopListRefresh}/>
		</div>}
		{calendarType === "Reserved_Shifts" && <div>
			<ReservedShifts {...props} />
		</div>}
	</div>)
}

export default Calendars